import React from "react";
import Emojis from "./emojis/Emojis";
const Footer = () => {
  return (
    <footer>
      React emojis app made with{" "}
      <Emojis data="RED_HEART" svg={true} width="15px" />{" "}
      <p>
        <a href="https://github.com/Aladin96/react-emojis-app" target="_blank">
          Github
        </a>{" "}
        -{" "}
        <a
          href="https://www.npmjs.com/package/react-emojis-app"
          target="_blank"
        >
          NPM
        </a>
      </p>
    </footer>
  );
};

export default Footer;
